import React from 'react';
import './DashboardTable.css';

/**
 * Reusable Dashboard Table Component
 * Displays data in a clean table format with scrolling support
 */
const DashboardTable = ({
  columns = [],
  data = [],
  loading = false,
  error = null,
  emptyMessage = 'No records available',
  onRowClick = null,
  className = ''
}) => {
  // Direct data usage instead of useMemo for React 16.2 compatibility
  const tableData = data;

  const renderHeader = () => (
    <table className="dashboard-table">
      <thead className="dashboard-table-head">
        <tr>
          {columns.map((col, idx) => (
            <th
              key={idx}
              className={`dashboard-table-th ${col.className || ''}`}
              style={{ width: col.width }}
            >
              {col.label}
            </th>
          ))}
        </tr>
      </thead>
    </table>
  );

  const renderRow = (row, rowIdx) => (
    <tr
      key={row.id || rowIdx}
      className={`dashboard-table-row ${onRowClick ? 'clickable' : ''}`}
      onClick={() => onRowClick && onRowClick(row)}
    >
      {columns.map((col, colIdx) => (
        <td 
          key={colIdx} 
          className={`dashboard-table-td ${col.className || ''}`}
          style={{ width: col.width }}
        >
          {col.render ? col.render(row[col.key], row, rowIdx) : row[col.key]}
        </td>
      ))}
    </tr>
  );

  const renderScrollableBody = () => {
    if (loading) {
      return (
        <div className="dashboard-table-scroll-wrapper">
          <table className="dashboard-table">
            <tbody>
              <tr>
                <td colSpan={columns.length} className="dashboard-table-loading">
                  Loading...
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    if (error) {
      return (
        <div className="dashboard-table-scroll-wrapper">
          <table className="dashboard-table">
            <tbody>
              <tr>
                <td colSpan={columns.length} className="dashboard-table-error">
                  ⚠ {error}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    if (!tableData || tableData.length === 0) {
      return (
        <div className="dashboard-table-scroll-wrapper">
          <table className="dashboard-table">
            <tbody>
              <tr>
                <td colSpan={columns.length} className="dashboard-table-empty">
                  {emptyMessage}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    return (
      <div className="dashboard-table-scroll-wrapper">
        <table className="dashboard-table">
          <tbody>
            {tableData.map((row, idx) => renderRow(row, idx))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className={`dashboard-table-wrapper ${className}`}>
      {renderHeader()}
      {renderScrollableBody()}
    </div>
  );
};

export default DashboardTable;



// WEBPACK FOOTER //
// ./src/shared/components/DashboardTable/index.js